import { useEffect } from "react";

const TidioChat = () => {
  useEffect(() => {
    if (import.meta.env.VITE_ENVIRONMENT === "production") {
      const script = document.createElement("script");
      script.src = "//code.tidio.co/cudt52zwd4nc1hv3rvj9lgto4s8ncfja.js";
      script.async = true;
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    }
  }, []);

  return null;
};

export default TidioChat;
